import type {
  AttributeSortDirection,
  AttributeSortField,
} from "./attributeUtils";
import type { AttributeWithCounts } from "./attributeUtils";
import { AttributesTableHeader } from "./AttributesTableHeader";
import { AttributesTableRow } from "./AttributesTableRow";

interface AttributesTableProps {
  attributes: AttributeWithCounts[];
  sortField: AttributeSortField;
  sortDirection: AttributeSortDirection;
  onSort: (field: AttributeSortField) => void;
  onEdit: (attribute: AttributeWithCounts) => void;
  onDelete: (attribute: AttributeWithCounts) => void;
  onViewCategories: (attribute: AttributeWithCounts) => void;
  onViewValues: (attribute: AttributeWithCounts) => void;
}

export function AttributesTable({
  attributes,
  sortField,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
  onViewCategories,
  onViewValues,
}: AttributesTableProps) {
  if (attributes.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No attributes found. Create your first attribute to get started.
      </div>
    );
  }

  return (
    <div className="max-h-[70vh] overflow-auto pb-8">
      <table className="w-full">
        <AttributesTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200">
          {attributes.map((attribute) => (
            <AttributesTableRow
              key={String(attribute.id)}
              attribute={attribute}
              onEdit={onEdit}
              onDelete={onDelete}
              onViewCategories={onViewCategories}
              onViewValues={onViewValues}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
